class Document {
  fileId: number;
  fileName: string;
  fileDescription: string;
  fileData: string;

  constructor(fileId: number, fileName: string, fileDescription: string, fileData: string) {
    this.fileId = fileId;
    this.fileName = fileName;
    this.fileDescription = fileDescription;
    this.fileData = fileData;
  }
}

export { Document };
